"use strict";
/**
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.completableAttributeNames = void 0;
/*
hasMinimum: whether the object has minimum required attributes to be kept for export
isCompleted: whether the object has all required attributes
isStarted: whether the object has at least one attribute filled
*/
exports.completableAttributeNames = ['hasMinimum', 'isCompleted', 'isStarted'];
//# sourceMappingURL=CompletableAttributes.js.map